var _g, _path, _path2, _g2, _path3, _path4, _path5, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 733,
    height: 805,
    viewBox: "0 0 733 805",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_979_248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 434.014,
    cy: 371.207,
    r: 98.2074,
    fill: "url(#paint0_linear_979_248)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.813 538.128L118 695H750.028L536.673 538.128H331.813Z",
    fill: "url(#paint1_linear_979_248)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_979_248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_979_248",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 385,
    y: 387,
    width: 96,
    height: 97
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M385.395 387.798H480.725V483.129H385.395V387.798Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_979_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.435 438.205C422.435 440.622 420.475 442.581 418.059 442.581C415.642 442.581 413.683 440.622 413.683 438.205C413.683 435.789 415.642 433.829 418.059 433.829C420.475 433.829 422.435 435.789 422.435 438.205Z",
    stroke: "url(#paint2_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.685 438.205C443.685 440.622 445.644 442.581 448.06 442.581C450.477 442.581 452.437 440.622 452.437 438.205C452.437 435.789 450.477 433.829 448.06 433.829C445.644 433.829 443.685 435.789 443.685 438.205Z",
    stroke: "url(#paint3_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.685 459.038L459.97 462.865C461.795 468.299 467.842 471.048 473.136 468.851C477.389 467.086 479.86 462.62 479.098 458.079L472.802 420.589L472.798 420.592C471.743 412.805 465.073 406.801 456.996 406.801C452.437 406.801 448.328 408.716 445.422 411.783H420.696C417.79 408.716 413.682 406.801 409.123 406.801C401.046 406.801 394.376 412.805 393.321 420.592L393.317 420.589L391.289 432.662",
    stroke: "url(#paint4_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.352 432.298L387.021 458.079C386.259 462.62 388.73 467.086 392.983 468.851C398.277 471.048 404.324 468.299 406.148 462.865L411.695 446.349C413.44 447.624 415.546 448.309 417.707 448.307C420.601 448.307 423.212 447.102 425.071 445.169H441.048C442.907 447.102 445.518 448.307 448.412 448.307C450.573 448.309 452.679 447.624 454.424 446.349L458.941 459.762",
    stroke: "url(#paint5_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.91 420.155H412.198V418.442C412.198 416.806 410.871 415.479 409.235 415.479C407.599 415.479 406.272 416.806 406.272 418.442V420.155H404.559C402.923 420.155 401.597 421.481 401.597 423.117C401.597 424.753 402.923 426.08 404.559 426.08H406.272V427.793C406.272 429.429 407.599 430.755 409.235 430.755C410.871 430.755 412.198 429.429 412.198 427.793V426.08H413.91C415.546 426.08 416.873 424.753 416.873 423.117C416.873 421.481 415.546 420.155 413.91 420.155Z",
    stroke: "url(#paint6_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.841 413.572C456.366 413.572 455.159 414.779 455.159 416.254C455.159 417.729 456.366 418.935 457.841 418.935C459.316 418.935 460.522 417.729 460.522 416.254C460.522 414.779 459.316 413.572 457.841 413.572Z",
    stroke: "url(#paint7_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.841 427.299C456.366 427.299 455.159 428.506 455.159 429.981V429.981C455.159 431.456 456.366 432.662 457.841 432.662C459.316 432.662 460.522 431.456 460.522 429.981V429.981C460.522 428.506 459.316 427.299 457.841 427.299Z",
    stroke: "url(#paint8_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.386 423.117C467.386 421.642 466.179 420.436 464.704 420.436C463.229 420.436 462.022 421.642 462.022 423.117C462.022 424.592 463.229 425.799 464.704 425.799C466.179 425.799 467.386 424.592 467.386 423.117Z",
    stroke: "url(#paint9_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.658 423.117C453.658 421.642 452.451 420.436 450.976 420.436C449.502 420.436 448.295 421.642 448.295 423.117C448.295 424.592 449.502 425.799 450.976 425.799C452.451 425.799 453.658 424.592 453.658 423.117Z",
    stroke: "url(#paint10_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.266 417.991H424.42C422.363 417.991 420.696 416.324 420.696 414.267V411.783",
    stroke: "url(#paint11_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.423 411.784V414.267C445.423 416.324 443.755 417.991 441.699 417.991H435.853",
    stroke: "url(#paint12_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.757 427.128H428.937",
    stroke: "url(#paint13_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.183 427.128H441.362",
    stroke: "url(#paint14_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.15 407.654V404.11C462.15 402.568 460.899 401.318 459.357 401.318H454.091C452.548 401.318 451.298 402.568 451.298 404.11V407.851",
    stroke: "url(#paint15_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.822 407.851V404.11C414.822 402.568 413.571 401.318 412.029 401.318H406.763C405.22 401.318 403.97 402.568 403.97 404.11V407.654",
    stroke: "url(#paint16_linear_979_248)",
    strokeWidth: 1.88542,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.192 435.2V343.152C335.192 340.892 337.926 339.76 339.524 341.358L379.985 381.818M486.745 381.82V488.579H379.986V381.82H486.745Z",
    stroke: "url(#paint17_linear_979_248)",
    strokeWidth: 3.77083,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M486.747 381.819L527.207 341.359C528.805 339.76 531.539 340.892 531.539 343.153V525.392C531.539 529.8 527.966 533.373 523.557 533.373H343.174C338.766 533.373 335.192 529.8 335.192 525.392V433.459",
    stroke: "url(#paint18_linear_979_248)",
    strokeWidth: 3.77083,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M508.201 360.364V510.035H358.53V360.364M379.986 488.579L337.544 531.021M406.676 488.579L385.458 531.024M433.366 488.579L433.372 531.028M460.055 488.579L481.287 531.031M486.745 488.579L529.201 531.035M486.741 461.896L531.528 483.114M486.741 435.206L531.532 435.2M486.741 408.517L531.535 387.285M379.986 461.896L335.199 483.114M379.986 435.206L335.196 435.2M379.986 408.517L335.192 387.285",
    stroke: "url(#paint19_linear_979_248)",
    strokeWidth: 3.77083,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_979_248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.095 340.744C458.095 349.846 465.657 357.299 475.184 357.834C465.657 358.369 458.095 365.822 458.095 374.924C458.095 365.822 450.533 358.369 441.005 357.834C450.533 357.299 458.095 349.846 458.095 340.744Z",
    fill: "url(#paint20_linear_979_248)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_979_248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M414.692 314.467C414.692 330.071 427.655 342.847 443.988 343.764C427.655 344.681 414.692 357.457 414.692 373.061C414.692 357.457 401.729 344.681 385.395 343.764C401.729 342.847 414.692 330.071 414.692 314.467Z",
    fill: "url(#paint21_linear_979_248)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_979_248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.542 303.467C449.542 311.269 456.024 317.657 464.19 318.116C456.024 318.574 449.542 324.962 449.542 332.764C449.542 324.962 443.061 318.574 434.894 318.116C443.061 317.657 449.542 311.269 449.542 303.467Z",
    fill: "url(#paint22_linear_979_248)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_979_248",
    x: 0.406647,
    y: -62.4,
    width: 867.215,
    height: 867.215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 167.7,
    result: "effect1_foregroundBlur_979_248"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_979_248",
    x1: 361.736,
    y1: 413.991,
    x2: 488.79,
    y2: 328.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_979_248",
    x1: 118,
    y1: 616.564,
    x2: 750.028,
    y2: 616.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_979_248",
    x1: 413.683,
    y1: 438.205,
    x2: 422.435,
    y2: 438.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_979_248",
    x1: 443.685,
    y1: 438.205,
    x2: 452.437,
    y2: 438.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_979_248",
    x1: 391.289,
    y1: 438.205,
    x2: 479.235,
    y2: 438.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_979_248",
    x1: 386.884,
    y1: 450.954,
    x2: 458.941,
    y2: 450.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_979_248",
    x1: 401.597,
    y1: 423.117,
    x2: 416.873,
    y2: 423.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_979_248",
    x1: 455.159,
    y1: 416.254,
    x2: 460.522,
    y2: 416.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_979_248",
    x1: 455.159,
    y1: 429.981,
    x2: 460.522,
    y2: 429.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_979_248",
    x1: 462.022,
    y1: 423.117,
    x2: 467.386,
    y2: 423.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_979_248",
    x1: 448.295,
    y1: 423.117,
    x2: 453.658,
    y2: 423.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_979_248",
    x1: 420.696,
    y1: 414.887,
    x2: 430.266,
    y2: 414.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_979_248",
    x1: 435.853,
    y1: 414.887,
    x2: 445.423,
    y2: 414.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_979_248",
    x1: 424.757,
    y1: 426.628,
    x2: 428.937,
    y2: 426.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_979_248",
    x1: 437.183,
    y1: 426.628,
    x2: 441.362,
    y2: 426.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_979_248",
    x1: 451.298,
    y1: 404.584,
    x2: 462.15,
    y2: 404.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_979_248",
    x1: 403.97,
    y1: 404.584,
    x2: 414.822,
    y2: 404.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_979_248",
    x1: 335.192,
    y1: 414.594,
    x2: 486.745,
    y2: 414.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_979_248",
    x1: 335.192,
    y1: 436.992,
    x2: 531.539,
    y2: 436.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_979_248",
    x1: 335.192,
    y1: 445.7,
    x2: 531.535,
    y2: 445.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_979_248",
    x1: 441.005,
    y1: 357.834,
    x2: 475.184,
    y2: 357.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_979_248",
    x1: 385.395,
    y1: 343.764,
    x2: 443.988,
    y2: 343.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_979_248",
    x1: 434.894,
    y1: 318.116,
    x2: 464.19,
    y2: 318.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE2FBA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_979_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.3308,
    height: 95.3308,
    fill: "white",
    transform: "translate(385.395 387.798)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_979_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2213,
    height: 34.2213,
    fill: "white",
    transform: "translate(441.005 340.744)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_979_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.6651,
    height: 58.6651,
    fill: "white",
    transform: "translate(385.395 314.467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_979_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.3326,
    height: 29.3326,
    fill: "white",
    transform: "translate(434.894 303.467)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBanner);
export default __webpack_public_path__ + "static/media/aboutBanner.99aed2a889af0c9a1bbc775d254be948.svg";
export { ForwardRef as ReactComponent };